import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import MuiDatePicker from '@mui/lab/MobileDatePicker'
import TextField from '@mui/material/TextField'

import { getDate } from 'helpers/dateTime'
import { selectDatePickerOpen } from 'redux/selectors'
import { closeDatePicker } from 'redux/actions'

const DatePicker = ({ onChange, onAccept }) => {
  const dispatch = useDispatch()
  const [value, setValue] = React.useState(getDate())
  const open = useSelector(selectDatePickerOpen)
  const onClose = useCallback(() => {
    dispatch(closeDatePicker())
  }, [dispatch])
  const onChangeFn = useCallback(
    newValue => {
      setValue(newValue)
      onChange && onChange(newValue)
    },
    [setValue, onChange]
  )
  const onAcceptFn = useCallback(() => {
    if (onAccept) {
      onAccept(value)
    }
  }, [onAccept, value])

  return (
    <MuiDatePicker
      open={open}
      onOpen={() => setValue(getDate())}
      onClose={onClose}
      value={value}
      minDate={getDate()}
      onChange={onChangeFn}
      onAccept={onAcceptFn}
      renderInput={params => (
        <TextField style={{ visibility: 'hidden' }} {...params} />
      )}
    />
  )
}

export default DatePicker
